import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { fetchQuizzes, getQuizParticipants } from "../redux/schoolSlice";
import TableComponent from "../../../../src/components/table/tableComponent"; // ✅ Adjust path if needed

const PracticeQuizzes = ({ selectedSchool }) => {
  const dispatch = useDispatch();
  const { quizzes, participants, loading, error } = useSelector(
    (state) => state.schools
  );

  const [selectedQuiz, setSelectedQuiz] = useState("");

  useEffect(() => {
    if (selectedSchool) {
      dispatch(fetchQuizzes({ type: "2" }));
    }
    setSelectedQuiz("");
  }, [dispatch, selectedSchool]);

  const handleQuizChange = (e) => {
    const quizId = e.target.value;
    setSelectedQuiz(quizId);
    if (quizId) {
      dispatch(getQuizParticipants({ quiz_id: quizId }));
    }
  };

  const tableColumns = [
    { Header: "S. No", accessor: "sno" },
    { Header: "Name", accessor: "username" },
    { Header: "Email", accessor: "email" },
    { Header: "Score", accessor: "score" },
    { Header: "Status", accessor: "participation_status" },
    { Header: "Completed At", accessor: "completed_at" },
  ];

  const processData = (data) =>
    data.map((p, index) => ({
      ...p,
      sno: index + 1,
      completed_at: p.completed_at
        ? new Date(p.completed_at).toLocaleString()
        : "-",
      participation_status: p.participation_status || "registered",
    }));

  const tableData = processData(participants || []);

  return (
    <div>
      {/* Skeleton for initial quiz loading */}
      {loading && <Skeleton count={5} height={25} style={{ marginBottom: "6px" }} />}
      {error && <p className="text-danger">Error: {error}</p>}

      {/* Quiz selection dropdown */}
      {!loading && quizzes?.length > 0 && (
        <select
          className="form-select w-50 mb-3 py-1"
          value={selectedQuiz}
          onChange={handleQuizChange}
          style={{ fontSize: "0.9rem" }}
        >
          <option value="">Select Quiz</option>
          {quizzes.map((quiz) => (
            <option key={quiz.id} value={quiz.id}>
              {quiz.title}
            </option>
          ))}
        </select>
      )}

      {/* Participants table */}
      {selectedQuiz && (
        <div>
          {loading && (
            <div style={{ width: "100%" }}>
              <Skeleton count={25} height={15} style={{ marginBottom: "4px" }} />
            </div>
          )}

          {!loading && tableData.length > 0 ? (
            <TableComponent tableColumns={tableColumns} tableData={tableData} />
          ) : (
            !loading && <p>No participants found for this quiz.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default PracticeQuizzes;
